export const fakeMemberships = [
    {
        id: 1,
        name: 'Abonnement Annuel Premium',
        renewal_event: { id: 101, name: 'Event Renouvellements 2024' },
        renewal_rate: { id: 201, name: 'Tarif Membre Premium', price: 99.0 },
        validity: 'fixed_period',
        validity_start_date: '2024-01-01T00:00:00Z',
        validity_end_date: '2024-12-31T23:59:59Z',
        renewal_frequency: 'anniversary',
        renewal_frequency_days: null,
        renewal_retry: 3,
        renewal_buffer_day_delta: 7,
        notification_identity: 42,
        rates: [
            { id: 301, name: 'Tarif Standard', price: 99.0 },
            { id: 302, name: 'Tarif Réduit', price: 49.0 }
        ],
        active_members_count: 150,
        status: 'active'
    },
    {
        id: 2,
        name: 'Abonnement Mensuel Classique',
        renewal_event: { id: 102, name: 'Event Renouvellements Mensuel' },
        renewal_rate: { id: 202, name: 'Tarif Membre Classique', price: 12.0 },
        validity: 'fixed_period',
        validity_start_date: '2024-03-15T00:00:00Z',
        validity_end_date: '2025-03-14T23:59:59Z',
        renewal_frequency: 'delta',
        renewal_frequency_days: 30,
        renewal_retry: 2,
        renewal_buffer_day_delta: 5,
        notification_identity: 42,
        rates: [{ id: 303, name: 'Tarif Mensuel', price: 12.0 }],
        active_members_count: 87,
        status: 'over'
    },
    {
        id: 3,
        name: 'Carte Fidélité Sans Expiration',
        renewal_event: { id: 103, name: 'Event Fidélité' },
        renewal_rate: { id: 203, name: 'Tarif Fidélité', price: 0.0 },
        validity: 'no_expiry',
        validity_start_date: null,
        validity_end_date: null,
        renewal_frequency: 'anniversary',
        renewal_frequency_days: null,
        renewal_retry: 1,
        renewal_buffer_day_delta: 3,
        notification_identity: null,
        rates: [{ id: 304, name: 'Tarif Gratuit', price: 0.0 }],
        active_members_count: 320,
        status: 'archived'
    },
    {
        id: 4,
        name: 'Pass Saisonnier Été',
        renewal_event: { id: 104, name: 'Event Pass Saisonnier' },
        renewal_rate: { id: 204, name: 'Tarif Saisonnier', price: 35.0 },
        validity: 'fixed_period',
        validity_start_date: '2024-06-01T00:00:00Z',
        validity_end_date: '2024-08-31T23:59:59Z',
        renewal_frequency: 'anniversary',
        renewal_frequency_days: null,
        renewal_retry: 2,
        renewal_buffer_day_delta: 10,
        notification_identity: 43,
        rates: [
            { id: 305, name: 'Tarif Adulte', price: 35.0 },
            { id: 306, name: 'Tarif Enfant', price: 20.0 }
        ],
        active_members_count: 54,
        status: 'active'
    },
    {
        id: 5,
        name: 'Abonnement Trimestriel',
        renewal_event: { id: 105, name: 'Event Renouvellements Trimestriel' },
        renewal_rate: { id: 205, name: 'Tarif Trimestriel', price: 29.0 },
        validity: 'anniversary',
        validity_start_date: null,
        validity_end_date: null,
        renewal_frequency: 'delta',
        renewal_frequency_days: 90,
        renewal_retry: 3,
        renewal_buffer_day_delta: 7,
        notification_identity: 42,
        rates: [{ id: 307, name: 'Tarif Trimestriel', price: 29.0 }],
        active_members_count: 210,
        status: 'active'
    },
    {
        id: 6,
        name: 'Membership VIP',
        renewal_event: { id: 106, name: 'Event VIP Renouvellements' },
        renewal_rate: { id: 206, name: 'Tarif VIP', price: 199.0 },
        validity: 'no_expiry',
        validity_start_date: null,
        validity_end_date: null,
        renewal_frequency: 'anniversary',
        renewal_frequency_days: null,
        renewal_retry: 5,
        renewal_buffer_day_delta: 14,
        notification_identity: 44,
        rates: [{ id: 308, name: 'Tarif VIP', price: 199.0 }],
        active_members_count: 18,
        status: 'active'
    },
    {
        id: 7,
        name: 'Abonnement Annuel Standard',
        renewal_event: { id: 107, name: 'Event Renouvellements Standard' },
        renewal_rate: { id: 207, name: 'Tarif Standard Annuel', price: 79.0 },
        validity: 'fixed_period',
        validity_start_date: '2023-01-01T00:00:00Z',
        validity_end_date: '2023-12-31T23:59:59Z',
        renewal_frequency: 'anniversary',
        renewal_frequency_days: null,
        renewal_retry: 2,
        renewal_buffer_day_delta: 7,
        notification_identity: 42,
        rates: [{ id: 309, name: 'Tarif Standard', price: 79.0 }],
        active_members_count: 0,
        status: 'inactive'
    },
    {
        id: 8,
        name: 'Abonnement Événement Supprimé',
        renewal_event: null,
        renewal_rate: { id: 210, name: 'Tarif Standard', price: 15.0 },
        validity: 'no_expiry',
        validity_start_date: null,
        validity_end_date: null,
        renewal_frequency: 'anniversary',
        renewal_frequency_days: null,
        renewal_retry: 1,
        renewal_buffer_day_delta: 5,
        notification_identity: null,
        rates: [{ id: 310, name: 'Tarif Standard', price: 15.0 }],
        active_members_count: 3,
        status: 'over'
    }
];

export const fakeMembers = [
    {
        id: 1001,
        member_id: 'MBR-2024-001',
        membership: 1,
        expiry_date: '2024-12-31T23:59:59Z',
        next_renewal_date: '2024-12-01T00:00:00Z',
        last_renewal_date: '2024-01-01T00:00:00Z',
        status: 'active',
        renewal_token: 'tok_abc123',
        attendees: [{ id: 5001, firstname: 'Marie', lastname: 'Dupont', email: 'marie.dupont@email.com' }]
    },
    {
        id: 1002,
        member_id: 'MBR-2024-002',
        membership: 1,
        expiry_date: '2024-12-31T23:59:59Z',
        next_renewal_date: '2024-12-01T00:00:00Z',
        last_renewal_date: '2024-01-01T00:00:00Z',
        status: 'active',
        renewal_token: 'tok_def456',
        attendees: [{ id: 5002, firstname: 'Jean', lastname: 'Martin', email: 'jean.martin@email.com' }]
    },
    {
        id: 1003,
        member_id: 'MBR-2024-003',
        membership: 2,
        expiry_date: '2025-03-14T23:59:59Z',
        next_renewal_date: '2024-12-15T00:00:00Z',
        last_renewal_date: '2024-11-15T00:00:00Z',
        status: 'active',
        renewal_token: 'tok_ghi789',
        attendees: [{ id: 5003, firstname: 'Sophie', lastname: 'Bernard', email: 'sophie.bernard@email.com' }]
    },
    {
        id: 1004,
        member_id: 'MBR-2024-004',
        membership: 3,
        expiry_date: null,
        next_renewal_date: '2025-01-10T00:00:00Z',
        last_renewal_date: '2024-01-10T00:00:00Z',
        status: 'active',
        renewal_token: 'tok_jkl012',
        attendees: [{ id: 5004, firstname: 'Pierre', lastname: 'Leroy', email: 'pierre.leroy@email.com' }]
    },
    {
        id: 1005,
        member_id: 'MBR-2023-099',
        membership: 7,
        expiry_date: '2023-12-31T23:59:59Z',
        next_renewal_date: null,
        last_renewal_date: '2023-01-01T00:00:00Z',
        status: 'expired',
        renewal_token: null,
        attendees: [{ id: 5005, firstname: 'Lucie', lastname: 'Moreau', email: 'lucie.moreau@email.com' }]
    }
];
